/* LMM Shop-Daten-Loader — laedt die Such-/Katalog-Registry BEI BEDARF.

   Hintergrund (2026-07-26): Bis heute rendert `layout/theme.liquid` die Registry bei jedem
   Seitenaufruf per Liquid — inklusive einer Produktlisten-Abfrage je Collection (259 Stueck).
   Das kostete rund 1,1 s Layout-Overhead pro Request und ~81 KB Inline-JSON in JEDER
   HTML-Antwort; Ursache der sporadischen HTTP-500-Fehler (Render-Timeouts).

   Neu: Die Daten liegen als statisches Asset (`lmm-shop-data.js`) und werden NICHT
   automatisch auf jeder Seite geladen, sondern
     - sofort, wenn die Seite sie zum Aufbau braucht (Suchseite, Roehren-Hierarchie) —
       das erledigt theme.liquid mit einem direkten <script>-Tag, nicht dieser Loader;
     - sonst beim ersten Kontakt mit einem Suchfeld (Fokus, Klick, Tastendruck, Hover).

   Fehlerfest: Faellt das Asset aus (404, Netzfehler, Blocker), passiert nichts weiter —
   die Intent-Aufloesung liefert dann einfach keine Kategorie-Treffer und Shopifys native
   Suche arbeitet unveraendert. Die Seite bricht nie ab.
*/
(function () {
  'use strict';
  if (window.LMMShopData) { return; }

  var geladen = false;
  var laeuft = null;
  var fehlgeschlagen = false;

  function schonDa() {
    // Inline-Fassung (Rollback-Stand) oder bereits geladenes Asset
    return !!document.getElementById('lmm-search-catalog-data');
  }

  function consumerBenachrichtigen() {
    // Intent Engine: bietet rebuildCatalog() an -> liest die Registry neu ein.
    try {
      if (window.LMMSearchIntent && typeof window.LMMSearchIntent.rebuildCatalog === 'function') {
        window.LMMSearchIntent.rebuildCatalog();
      }
    } catch (e) { /* Consumer-Fehler duerfen den Loader nicht stoppen */ }
    // Weitere Consumer koennen sich an dieses Event haengen.
    try {
      document.dispatchEvent(new CustomEvent('lmm:shop-data-ready'));
    } catch (e) { /* aeltere Browser ohne CustomEvent-Konstruktor */ }
  }

  function laden() {
    if (geladen || schonDa()) { geladen = true; return Promise.resolve(true); }
    if (fehlgeschlagen) { return Promise.resolve(false); }
    if (laeuft) { return laeuft; }
    var url = window.LMM_SHOP_DATA_URL;
    if (!url) { fehlgeschlagen = true; return Promise.resolve(false); }

    laeuft = new Promise(function (fertig) {
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = function () {
        geladen = true;
        laeuft = null;
        consumerBenachrichtigen();
        fertig(true);
      };
      s.onerror = function () {
        fehlgeschlagen = true;   // kein Dauer-Retry, kein Blockieren der Suche
        laeuft = null;
        fertig(false);
      };
      (document.head || document.documentElement).appendChild(s);
    });
    return laeuft;
  }

  window.LMMShopData = {
    load: laden,
    isLoaded: function () { return geladen || schonDa(); },
    failed: function () { return fehlgeschlagen; }
  };

  // --- Ausloeser: erster Kontakt mit einer Sucheingabe -------------------------
  var SUCHE = 'input[type="search"], [data-rg-search], [name="q"], .search__input,' +
              ' search-modal, [data-lmm-search], .lmmh-search, form[action$="/search"]';

  function passt(el) {
    if (!el || !el.closest) { return false; }
    return !!el.closest(SUCHE);
  }

  function ausloeser(e) {
    if (geladen || fehlgeschlagen) { abmelden(); return; }
    if (!passt(e.target)) { return; }
    abmelden();
    laden();
  }

  function abmelden() {
    document.removeEventListener('focusin', ausloeser, true);
    document.removeEventListener('pointerover', ausloeser, true);
    document.removeEventListener('keydown', ausloeser, true);
    document.removeEventListener('click', ausloeser, true);
  }

  document.addEventListener('focusin', ausloeser, true);
  document.addEventListener('pointerover', ausloeser, true);
  document.addEventListener('keydown', ausloeser, true);
  document.addEventListener('click', ausloeser, true);

  // Falls die Seite die Daten sofort braucht, hat theme.liquid das Asset bereits
  // synchron geladen — dann ist hier nichts mehr zu tun.
  if (schonDa()) { geladen = true; abmelden(); }
})();
